<div class="wrap">
  <div class="content">
    <h2>Images du club</h2>

    <ng-container *ngIf="!isLoadingAllImages">
      <div class="gallery">
      <ng-container *ngFor="let image of images">

        <div class="img" (click)="chooseImage(image, !image.isSelected)">
          <app-image-offer [offerKey]="image.offerKey" [width]="100" [height]="'150px'"></app-image-offer>

          <mat-checkbox [color]="color" [checked]="image.isSelected" (click)="$event.stopPropagation()"
            (change)="chooseImage(image, $event.checked)"></mat-checkbox>
        </div>

      </ng-container>

      <ng-container *ngIf="images.length === 0">
        <p>Il n'y a encore aucune image importée pour ce club.</p>
      </ng-container>
    </div>
    </ng-container>

    <mat-spinner *ngIf="isLoadingAllImages" [diameter]="75"></mat-spinner>
  </div>

    <div class="btn_action">
      <button type="button" class="back" (click)="dialogRef.close()">Annuler</button>
      <button (click)="confirm()" class="confirm" form="choiceClubForm" [disabled]="imageSelected === null" [style.opacity]="!imageSelected? .5 : 1" >Confirmer</button>
    </div>

</div>
